import { disableLanguage } from '../../../shared/DOM/disableLanguage.js';
import { isDocumentValid } from '../api/isDocumentValid.js';
import { renderOtp } from './otp/renderOtp.js';
import { renderViewdocsForm } from './renderViewdocs.js';
import { renderViewdocsHeader } from './renderViewdocsHeader.js';

// Tenemos preparado un error1 por si distinguimos bien las peticiones REQUEST que fallan por conexión
export const ERROR_TYPES = {
  REQUEST: '-1',
  PRINT: '-2',
  INVALID: '-3',
  CREDENTIALS: '-4',
  CREDENTIALS_7: 'error2',
  CREDENTIALS_38: 'error3',
  CREDENTIALS_35: 'error4',
};

export const INCORRECT_ACCESS = {
  icon: 'ban',
  title: 'viewdoc.step.access.title',
  message: 'viewdoc.step.access.info',
};

export const EXPIRED_LINK = {
  icon: 'file-xmark',
  title: 'viewdoc.step.title',
  message: 'viewdoc.step.info',
};

export const ERROR_CREDENTIALS = 'CREDENTIALS';

export const ERROR_REQUEST = 'REQUEST';

export const ERROR_PRINT = 'PRINT';

/**
 * renderError
 *
 * @param {*} error
 * @param {*} viewdocsData
 *  {
 *    icon,
 *    title,
 *    message,
 *    message2,
 *    allowBack
 *  }
 */
export function renderError(error, viewdocsData) {
  const eForm = document.getElementById(`form-viewdocs${viewdocsData.form}`);

  const message = edicom.locale.translate(error.message);
  const messageAlt = error.message2 ? `<br/><br/>${edicom.locale.translate(error.message2)}` : '';

  eForm.render({
    value: {},
    view: {
      properties: [
        {
          type: 'object',
          name: 'error.html',
          cols: 8,
          properties: [
            {
              name: 'errorAlert',
              type: 'alert',
              metadata: {
                closable: false,
                style: 'danger-flat',
                content: `<div style="white-space:normal">${message}${messageAlt}</div>`,
              },
              cols: 8,
            },
          ],
        },
      ],
    },
  });

  renderViewdocsHeader(error.icon || '', error.title);

  createErrorFooter(error.allowBack);

  const eBtnBack = getErrorBtnBack();

  initError();

  /////////////////////////////

  function initError() {
    error.allowBack && disableLanguage();

    // Opcional
    eBtnBack?.addEventListener('click', () => {
      backForm();
    });
  }

  // eBtnBack
  function backForm() {
    createErrorFooter(false); // destroy
    isOtpLink(viewdocsData) ? renderOtp(viewdocsData.ta, viewdocsData) : renderViewdocsForm(viewdocsData, true);
  }
}

function isOtpLink(viewdocs) {
  return isDocumentValid(viewdocs) && viewdocs.ta && viewdocs.printOtpRequired;
}

function createErrorFooter(allowBack) {
  document.getElementById('container-footer').innerHTML = allowBack
    ? `<footer class="container--footer">
    <ewc-toolbar>
        <ewc-button icon="arrow-left" icon-rtl view-name="btnBack" label="${edicom.locale.translate('global.back')}" ec-primary no-responsive></ewc-button>
    </ewc-toolbar>
  </footer>`
    : '';
}

function getErrorBtnBack() {
  return document.querySelector('ewc-button[view-name="btnBack"]');
}

export function onCatchError(e, viewdocsForm) {
  const errorType = ERROR_TYPES[e.message] || ERROR_TYPES.REQUEST;
  const isCredentialsError = errorType === ERROR_TYPES.CREDENTIALS || errorType.startsWith('error');

  let error;

  if (isCredentialsError) {
    error = {
      title: 'viewdoc.step.credentials.title',
    };

    if (errorType === ERROR_TYPES.CREDENTIALS) {
      error.allowBack = true;
      error.message = 'viewdoc.step.credentials.info';
      error.message2 = 'viewdoc.step.credentials.info2';
    } else {
      error.message = 'viewdoc.step.credentials.error';
      error.message2 = errorType === ERROR_TYPES.CREDENTIALS_35 ? 'login.error_otp_notconfigured' : `viewdoc.step.credentials.${errorType}`;
    }
  } else {
    // Error por defecto
    error = EXPIRED_LINK;
  }

  renderError(error, viewdocsForm);
}
